import { z } from 'zod';
import { colombianHolidaysBetween, defaultColombianCalendar } from '@xiltrion/calendario';
import { DEFAULT_TIMEZONE } from './ficha.js';
/**
 * Calendario hábil de la entidad (GUIA-AGENTES.md §3.11): jornada por día y festivos. Es el calendario por defecto de
 * todas las apps; una app puede tener además calendarios propios (los de los plazos de SGDEA) que parten de este. La
 * zona horaria es la de la ficha.
 */
const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;
const minutes = (hhmm) => Number(hhmm.slice(0, 2)) * 60 + Number(hhmm.slice(3, 5));
export const WEEKDAY_LABEL = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export const workingWindowSchema = z.object({
    /** 0 = domingo … 6 = sábado. */
    weekday: z.number().int().min(0).max(6),
    start: z.string().regex(HHMM, 'Hora como 08:00'),
    end: z.string().regex(HHMM, 'Hora como 17:00'),
}).refine((w) => minutes(w.start) < minutes(w.end), { message: 'La jornada termina antes de empezar', path: ['end'] });
export const entityCalendarSchema = z.object({
    workingDays: z.array(workingWindowSchema).max(28),
    holidays: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha como 2026-12-25')).max(600)
        .transform((list) => [...new Set(list)].sort()),
}).superRefine((c, ctx) => {
    // Dos franjas del mismo día no se pisan (sí puede haber mañana y tarde).
    for (let d = 0; d < 7; d++) {
        const day = c.workingDays.filter((w) => w.weekday === d).sort((a, b) => minutes(a.start) - minutes(b.start));
        for (let i = 1; i < day.length; i++) {
            if (minutes(day[i].start) < minutes(day[i - 1].end))
                ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['workingDays'], message: `Las franjas del ${WEEKDAY_LABEL[d].toLowerCase()} se cruzan` });
        }
    }
});
/** Lunes a viernes de 8:00 a 17:00 con los festivos de Colombia del año anterior y los siguientes. */
export function defaultEntityCalendar(now = new Date()) {
    const c = defaultColombianCalendar(now.getUTCFullYear());
    return { workingDays: c.workingDays, holidays: c.holidays };
}
/** Agrega los festivos de Colombia de esos años (sin quitar los que la entidad ya tenía). */
export function withColombianHolidays(cal, fromYear, toYear) {
    return { ...cal, holidays: [...new Set([...cal.holidays, ...colombianHolidaysBetween(fromYear, toYear)])].sort() };
}
/** El calendario listo para `@xiltrion/calendario` (`addBusinessDays`, `computeDueAt`…). */
export function toBusinessCalendar(cal, timezone = DEFAULT_TIMEZONE) {
    return { code: 'DEFAULT', name: 'Calendario hábil', timezone, workingDays: cal.workingDays, holidays: cal.holidays };
}
//# sourceMappingURL=calendario.js.map